const EXTENSION_OR_ENDPOINT_MIN: string = '20'
const EXTENSION_OR_ENDPOINT_MAX: string = '29'
const EXTENSION_OR_ENDPOINT_TRUNKING: string = '21'
const EXTENSION_OR_ENDPOINT_HOSPITALITY: string = '22'
const SUPER_GROUP: string = '39'
const GROUP_MIN: string = '40'
const GROUP_MAX: string = '59'
const GROUP_COLLECTIVE: string = '40'
const GROUP_LINEAR: string = '41'
const GROUP_CYCLIC: string = '42'
export const GROUP_ACD: string = '43'
const GROUP_TRUNK: string = '44'
const GROUP_VOICEMAIL: string = '50'
const GROUP_PAGE: string = '55'
export const DEPARTMENT: string = '56'
export const SECURITY_GROUP: string = '57'
export const ENTERPRISE_GROUP: string = '58'
export const SERVICE_PROVIDER_GROUP: string = '59'
const PILOTNUMBER: string = '100' // Also used as a DDI number description entry on the Siemens HiPath 3000 telephone system.
export const DNIS_ENTRY: string = '110'

export const SCOPE_GROUPS: string[] = [
    ENTERPRISE_GROUP,
    SERVICE_PROVIDER_GROUP,
    DEPARTMENT,
    SUPER_GROUP,
    SECURITY_GROUP
]

export const DEVICE_FILTERS: string[] = [
    EXTENSION_OR_ENDPOINT_MIN,
    EXTENSION_OR_ENDPOINT_TRUNKING,
    EXTENSION_OR_ENDPOINT_HOSPITALITY,
    EXTENSION_OR_ENDPOINT_MAX,
    GROUP_MIN,
    GROUP_LINEAR,
    GROUP_CYCLIC,
    GROUP_ACD,
    GROUP_VOICEMAIL,
    GROUP_PAGE,
    PILOTNUMBER
]

export const ALL_GROUPS: string[] = [
    SUPER_GROUP,
    GROUP_COLLECTIVE,
    GROUP_LINEAR,
    GROUP_CYCLIC,
    GROUP_ACD,
    GROUP_TRUNK,
    GROUP_VOICEMAIL,
    GROUP_PAGE
]

export const GROUPS: string[] = [SUPER_GROUP, GROUP_MIN, GROUP_MAX]

// Device only filters.
export const DEVICE_FILTER_EXTENSIONS_ONLY: string[] = [EXTENSION_OR_ENDPOINT_MIN, EXTENSION_OR_ENDPOINT_MAX]

// Group filters.
export const DEVICE_FILTER_ACD_GROUPS: string[] = [GROUP_ACD]
export const DEVICE_FILTER_NON_ACD_GROUPS: string[] = [GROUP_COLLECTIVE, `${GROUP_CYCLIC}:${GROUP_TRUNK}`, GROUP_MAX]
export const DEVICE_FILTER_ANY_GROUPS: string[] = [GROUP_MIN, GROUP_MAX]
export const DEVICE_FILTER_NONE: string[] = []

// Device Fields
export enum DeviceFields {
    USERS = 'Users',
    ID_ON_TEL_SYS = 'IDOnTelSys',
    TELSYS_USER_ID = 'TelSysUserID',
    ACD_AGENT_NUMBER = 'ACDAgentNumber',
    OVERRIDE_MONITORING = 'OverrideMonitoring',
    GROUP_MEMBERSHIP = 'GroupMembership',
    TELSYS_USERNAME = 'TelSysUsername',
    LICENCE_TYPE = 'LicenseType',
    DEVICE_TYPE_ID = 'DeviceTypeID',
    QUEUE_STATUS = 'QueueStatus',
    DISABLE_RT_MONITORING = 'DisableRTMonitoring',
    QUEUE_COMPATIBILITY = 'QueueCompatibility',
    ID_ON_TEL_SYS_OWNER = 'IDOnTelSysOwner',
    CALL_QUEUE_CAPTURE_ERROR_MESSAGE = 'CallQueueCaptureErrorMessage',
    PRIMARY_EMAIL = 'PrimaryEmail'
}

export const EPT_DEVICE_FIELDS: string = `${DeviceFields.USERS},${DeviceFields.TELSYS_USERNAME},${DeviceFields.ACD_AGENT_NUMBER},${DeviceFields.LICENCE_TYPE},${DeviceFields.PRIMARY_EMAIL}`

export const MANAGE_QUEUES_FIELDS: string = `${DeviceFields.QUEUE_STATUS},${DeviceFields.DISABLE_RT_MONITORING},${DeviceFields.TELSYS_USER_ID},${DeviceFields.QUEUE_COMPATIBILITY},${DeviceFields.ID_ON_TEL_SYS_OWNER},${DeviceFields.CALL_QUEUE_CAPTURE_ERROR_MESSAGE}`
